import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRelatedCompaniesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.45001 16.75H2.90002C1.47002 16.75 0.75 16.03 0.75 14.6V2.90002C0.75 1.47002 1.47002 0.75 2.90002 0.75H7.20001C8.63001 0.75 9.35 1.47002 9.35 2.90002V4.75",
			className: "stroke",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1484 4.75V2.90002C12.1484 1.47002 12.8684 0.75 14.2984 0.75H18.5984C20.0284 0.75 20.7484 1.47002 20.7484 2.90002V14.6C20.7484 16.03 20.0284 16.75 18.5984 16.75H16.1184",
			className: "stroke",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1192 7.16998V18.33C16.1192 19.94 15.3193 20.75 13.7093 20.75H7.8692C6.2592 20.75 5.44922 19.94 5.44922 18.33V7.16998C5.44922 5.55998 6.2592 4.75 7.8692 4.75H13.7093C15.3193 4.75 16.1192 5.55998 16.1192 7.16998Z",
			className: "stroke",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.75 9.75H12.75",
			className: "stroke",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.75 12.75H12.75",
			className: "stroke",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.75 20.75V17.75",
			className: "stroke",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRelatedCompaniesIcon;
